export const TRACK_EVENTS = [
  "blog_view",
  "blog_read_progress",
  "outbound_click",
  "message_login_prompt",
  "message_submit",
];

const BLOCKED_PROPERTY_KEYS = /^(email|userId|user_id|message|token|password|authorization)$/i;

export function isAllowedEvent(event) {
  return TRACK_EVENTS.includes(event);
}

export function sanitizeProperties(properties) {
  if (!properties || typeof properties !== "object" || Array.isArray(properties)) {
    return {};
  }

  const clean = {};

  for (const [key, value] of Object.entries(properties)) {
    if (BLOCKED_PROPERTY_KEYS.test(key)) continue;
    if (typeof value === "string" && value.length > 200) {
      clean[key] = value.slice(0, 200);
      continue;
    }
    if (
      value === null ||
      typeof value === "string" ||
      typeof value === "number" ||
      typeof value === "boolean"
    ) {
      clean[key] = value;
    }
  }

  return clean;
}
